<app-navbar></app-navbar>
<div class="courses-container">
	<div class="course" *ngFor="let movie of state.results" (click) = "onMovieClick(movie)">
		<div class="course-preview">
			<img style="width:100%;height:100%"
				src="{{ movie.poster_path ? 'https://image.tmdb.org/t/p/original' + movie.poster_path : 'https://lh6.googleusercontent.com/proxy/oqZfItyVr9ljKfhHVg4MGubil6-uYpFbhxFQ5DrA5cLUH4KzNVq4Im2PxJxnVY07oWfBqBC6GKet7dT-m2CkuY8q7U0c6K9gkyoujcJUzR1lkrpxlC5mPIZIsm4Cfrsah4AwOGnYXUieuyR2Tfnn60k=s0-d'}}"
				alt="Girl in a jacket">
		</div>
		<div class="course-info">
			<div class="progress-container">
				<!-- <img style="width:20px;height:20px;margin-right:5px" src="/assets/star.png" alt="image">
				<span class="progress-text">
					{{movie.vote_average}}
				</span> -->
				<div fxFlex fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px"> 
					<img style="width:20px;height:20px;" src="/assets/star.png" alt="image">
					<span class="progress-text" class="text-xl font-semibold">
					  {{movie.vote_average}}
					</span>
				  </div>
			</div>
			<h4>{{movie.title}}</h4>
			<h6>{{movie.overview}}</h6>
		</div>
	</div>
</div>
<app-footer></app-footer>